/* eslint-disable @typescript-eslint/naming-convention */
'use client';

import { useState } from 'react';

import Link from 'next/link';

function sanitizePath(pathname: any): any {
  if (typeof pathname !== 'string') return pathname;
  let sanitized = pathname;
  if (sanitized.startsWith('http')) return sanitized;
  if (/^(mailto:|tel:|#)/.test(sanitized)) return sanitized;
  if (!sanitized.startsWith('/')) sanitized = `/${sanitized}`;
  return sanitized;
}

type Props = React.ComponentProps<typeof Link>;

export const PrefetchLink = (props: Props) => {
  const { href, children, ...rest } = props;
  const { prefetch = false } = props;

  const [shouldPrefetch, setShouldPrefetch] = useState(prefetch);
  const sanitizedHref = sanitizePath(href);

  return (
    <Link
      prefetch={shouldPrefetch}
      href={sanitizedHref ?? '/'}
      onMouseEnter={() => setShouldPrefetch(true)}
      {...rest}
    >
      {children}
    </Link>
  );
};
